import {FirmUserRoleStatus, ROLE_ORDER, Role, isFirmAssignableRole} from '@sollapay/enums';

import type {CreatedAtFilter} from '@sollapay/ui/components';

export interface TeamFilterState {
  statuses: FirmUserRoleStatus[];
  roleKeys: string[];
  createdAt: CreatedAtFilter;
}

export const DEFAULT_TEAM_FILTER_STATE: TeamFilterState = {
  statuses: [],
  roleKeys: [],
  createdAt: 'all'
};

export const TEAM_STATUS_FILTER_OPTIONS: ReadonlyArray<{
  value: FirmUserRoleStatus;
  i18nKey: string;
}> = [
  {value: FirmUserRoleStatus.ACTIVE, i18nKey: 'status.active'},
  {value: FirmUserRoleStatus.PENDING, i18nKey: 'status.pending'}
];

/** Firm-assignable roles in display order; `value` doubles as the `common:roles.<value>` i18n key. */
export const TEAM_ROLE_FILTER_OPTIONS: readonly string[] = Object.values(Role)
  .filter(isFirmAssignableRole)
  .sort((a, b) => ROLE_ORDER[a] - ROLE_ORDER[b]);

export const CREATED_AT_FILTER_OPTIONS: ReadonlyArray<{value: CreatedAtFilter; i18nKey: string}> = [
  {value: 'all', i18nKey: 'filter.createdAt.all'},
  {value: '7d', i18nKey: 'filter.createdAt.last7days'},
  {value: '30d', i18nKey: 'filter.createdAt.last30days'},
  {value: '90d', i18nKey: 'filter.createdAt.last90days'}
];
